import { render, staticRenderFns } from "./v-file.vue?vue&type=template&id=195bbbcd&scoped=true&"
import script from "./v-file.vue?vue&type=script&lang=js&"
export * from "./v-file.vue?vue&type=script&lang=js&"
import style0 from "./v-file.vue?vue&type=style&index=0&id=195bbbcd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195bbbcd",
  null
  
)

export default component.exports